export default "__VITE_ASSET__jxlvk0$V__"